import { createResource } from './api';
import { toAttachmentParam } from './messages';

// Reply to pitches on a request: the server find-or-creates each pitch's conversation
// (origin: pitch). pitchIds are V1 ids (= migrate_ids) and MUST stay a top-level param —
// nested under data.attributes the server sees no filter and fans out to EVERY sent pitch.
// Omitting pitchIds is the deliberate Reply-All call: the server replies to every sent pitch.
// From V1, pass the numeric V1 request id: the server resolves it as a migrate_id.
// createResource routes the relative URL to V2 cross-origin (resolveApiUrl).
const send = async (requestIdOrSlug, {
  pitchIds, v2PitchIds, body, attachments = [], videoRequest = false,
}) => {
  const url = `/interact/api/messaging/requests/${requestIdOrSlug}/pitch_replies`;
  return createResource(url, {
    ...(pitchIds ? { pitch_ids: pitchIds } : {}),
    // Separate param: V2 primary keys, for pitches with no migrate_id (V2-native). The two
    // id spaces overlap numerically, so the server never guesses which one it was handed.
    ...(v2PitchIds ? { v2_pitch_ids: v2PitchIds } : {}),
    data: {
      attributes: {
        body,
        content_format: 'html',
        attachments: attachments.map(toAttachmentParam),
        video_request: !!videoRequest,
      },
    },
  });
};

export default { send };
